import classNames from "classnames"
import { HTMLProps } from "react"

export function VerticalFormStack({ className, children, ...rest }: HTMLProps<HTMLDivElement>) {
  return (
    <div className={classNames("flex flex-col gap-4", className)} {...rest}>
      {children}
    </div>
  )
}
